<!--  title -->
<template>
  <div class="sign-time" :class="active?'active':''">
    <div>{{signer}}</div>
    <div class="time-style" v-show="signDoen"><img src="@/assets/icon_sign_time.svg" style="margin-top: 5px;"> {{signatureTime}}</div>
  </div>
</template>
<script>
export default {
  name: 'sign-time',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    signDoen: {
      type: Boolean,
      default: false
    },
    signer: {
      type: String,
      default: ''
    },
    signatureTime: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="stylus" scoped>

.sign-time
  height 66px
  border-bottom 3px solid #eee
.sign-time.active
  border: 3px solid #025da3;
  border-radius: 5px;
  padding: 5px;
  font-size: 16px;
  font-weight: 700;
  color: #025da3;
.time-style
  padding-bottom:5px
  font-size: 0.8em;
  color:#a0a0a0
</style>
